export default __webpack_public_path__ + "static/smmIllustration-162e923ba23b4d8ec6d5ef3dc93f10cb.svg";